/* eslint-disable import/prefer-default-export */

export const subscriptionError = {
  INCORPORATION_PLAN_NOT_CONFIGURED: 'The incorporation plan is not configured',
  SUBSCRIPTION_NOT_CONFIGURED: 'That subscription plan is not configured',
  STATE_FEE_PLAN_NOT_CONFIGURED: 'The state fee plan is not configured',
  INCORPORATION_REQUIRED: 'Choose an option of incorporation',
  SUBSCRIPTION_PLAN_REQUIRE: 'Choose a subscription plan',
};
